import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'

export const TreeSimulationFormSchema = yup.object({
  name: yup.string().required().max(30).default(''),
  financingProgramId: yup.string().required().default(''),
  startDate: yup.date().required().default(null as unknown as Date),
  endDate: yup
    .date()
    .required()
    .default(null as unknown as Date)
    .test('min-end-date', () => t('treeSimulation.validation.endDateAfterStart'), (value, ctx) => {
      const { startDate } = ctx.parent as { startDate: Date | null }
      if (!value || !startDate) return true
      return value >= startDate
    }),
  applicantTreeId: yup.string().required().max(38).default(''),
  applicantTreeVersionId: yup.string().required().default(''),
  coapplicantTreeId: yup.string().max(38).default(''),
  coapplicantTreeVersionId: yup.string().default(''),
})

export type TreeSimulationFormSchemaType = yup.InferType<typeof TreeSimulationFormSchema>
